var render = function render(){var _vm=this,_c=_vm._self._c;return _c('textarea',{class:_vm.computedClasses,attrs:{"id":_vm.editorId,"cols":_vm.cols,"rows":_vm.rows}})
}
var staticRenderFns = []

export { render, staticRenderFns }